import React from 'react'

import '../css/Register.css';
import { VideoForm } from '../components/VideosApp/VideoForm';
export const VideosPages = () => {
    return (
        <VideoForm />
    )
}